import { productMatch } from "./productMatch";
const findItemOnWishlist = (currentWishlist, product) => {
  var _a, _b;
  const wishlist = Array.isArray(currentWishlist) ? currentWishlist[0] : currentWishlist;
  return (_b = (_a = wishlist == null ? void 0 : wishlist.items_v2) == null ? void 0 : _a.items) == null ? void 0 : _b.find((item) => productMatch(item.product, product));
};
export {
  findItemOnWishlist
};
